var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmptyFlag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 931,
    transform: "translate(-746 -287)",
    fill: "#FFFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -349,
    y: -160,
    width: 890,
    height: 638,
    rx: 4,
    fill: "#FFFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -348.5,
    y: -159.5,
    width: 889,
    height: 637,
    rx: 3.5,
    stroke: "#4E515B",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 96,
    fill: "#3E71F6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4788 119.683L48.4788 139.306C47.2788 140.908 48.4788 143.311 50.4788 143.311H141.479C143.079 143.311 144.279 141.709 143.879 140.307L139.279 122.286C138.679 120.284 137.279 118.682 135.479 117.881L127.079 114.477C126.079 114.077 125.279 113.476 124.479 112.675L114.879 102.063V83.0412C122.679 86.8456 130.679 75.8329 138.479 78.8364C140.079 79.4371 141.879 78.0355 141.879 76.4336V61.6166C141.879 60.8156 141.479 60.0147 140.879 59.6143C132.279 53.0067 123.679 66.6223 115.079 62.4175V56.0101C115.079 55.009 114.079 54.0078 113.079 54.0078C112.079 54.0078 111.079 54.8087 111.079 56.0101V85.444C109.679 84.2426 107.679 84.4428 107.879 84.4428C102.079 84.4428 96.6788 81.6396 93.2788 76.8341C92.4788 76.0332 90.8788 72.0285 87.8788 72.0285H70.4788C65.2788 69.2253 61.2788 64.62 59.2788 59.0136C58.4788 57.612 56.8788 56.811 55.2788 57.2115C53.4788 57.612 52.4788 59.414 53.2788 61.2161C56.2788 69.0251 62.2788 75.4325 69.8788 78.6361V117.481L67.0788 117.681C65.6788 117.881 64.4788 118.482 63.4788 119.683ZM110.879 91.6511V99.4601C108.079 100.862 105.679 104.266 102.079 102.664C101.879 102.664 99.0788 100.661 96.4788 103.064L90.0788 108.671H89.6788V85.444C96.6788 92.2518 107.879 94.2541 110.879 91.6511ZM79.8788 100.461C81.0788 100.461 81.8788 101.462 81.8788 102.464V110.673L77.6788 115.679V102.263C77.6788 101.462 78.6788 100.461 79.8788 100.461Z",
    fill: "#2D56BD",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6774 68.8239C85.4211 68.8239 90.0774 64.1623 90.0774 58.412C90.0774 52.6616 85.4211 48 79.6774 48C73.9336 48 69.2773 52.6616 69.2773 58.412C69.2773 64.1623 73.9336 68.8239 79.6774 68.8239Z",
    fill: "#2D56BD",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 931,
    fill: "white",
    transform: "translate(-746 -287)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-flag.c12af5e6.svg";
export { ForwardRef as ReactComponent };